import type { Locale, Messages } from '@ah/i18n';
import { el } from './el';
import { en } from './en';

export const messages: Record<Locale, Messages> = { el, en };
